<div class="container-fluid">
  <h1>
    APIs
  </h1>
  <form class="form-inline form-sm">
    <div class="mb-4"
         style="position: relative;">
      <i class="fa fa-search text-muted"
         style="position: absolute; margin-left: 7px;margin-top: 7px;"></i>
      <input name="searchInput"
             class="form-control form-control-sm"
             style="padding-left: 30px;width: 445px;"
             type="text"
             autocomplete="off"
             title="Find APIs by specifying a value within the API attributes: API Display Name, Description, Version, Context, or &quot;Subscribed&quot;."
             [(ngModel)]="searchText">
    </div>
  </form>

  <!--<input class="form-control"-->
         <!--style="width: 544px;"-->
         <!--type="search"-->
         <!--title="Search for APIs by specifying a value within the API attributes: API Display Name, Description, Version, Context, or &quot;Subscribed&quot;."-->
         <!--[(ngModel)]="searchText">-->

  <div class="card-deck">
    <a class="card card-link mb-4"
       routerLink="/apis/{{api.id}}"
       [queryParams]="{title: api.displayName}"
       *ngFor="let api of apis?.list | apisFilter : searchText">
      <div class="card-body">
        <div class="aqx-api-image-container">
          <img *ngIf="api.thumbnailUri"
               [src]="getThumbnailUri(api)">
        </div>
        <div class="aqx-api-title-and-text text-overflow-fade">
          <h2 class="card-title">
            {{api.displayName}}
          </h2>
          <p class="card-text">
            {{api.description}}
          </p>
        </div>
      </div>
      <div class="card-footer text-muted small">
        <div class="float-left">
          <!--<span class="d-none d-lg-inline-block">-->
           <span>
            <strong>Version</strong> {{api.version}}
          </span>
          <span class="ml-2">
            <strong>Context</strong> {{api.context}}
          </span>
        </div>
        <div *ngIf="api.subscriptions && api.subscriptions.count > 0"
             class="float-right">
         <div class="badge badge-info"
              style="font-size: 100%; font-weight: normal;">
            <i class="fas fa-check"></i> Subscribed
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
